/* Единый источник данных о брендах и категориях для фильтров и URL.
Реальные данные — в src/data/catalogMeta.json (общий файл с prerender.js).
Новое: динамические бренды подгружаются с бэкенда. */
import { useState, useEffect } from 'react';
import catalogMeta from './data/catalogMeta.json';

// Статические бренды с ручными SEO-текстами (базовые)
const STATIC_BRANDS = catalogMeta.BRANDS;
export const CATEGORIES = catalogMeta.CATEGORIES;

// Хук: статика + динамика из каталога
export function useBrands() {
    const [brands, setBrands] = useState(STATIC_BRANDS);

    useEffect(() => {
        let stop = false;
        fetch('/api/catalog/brands')
            .then(r => r.ok ? r.json() : [])
            .then(dynamic => {
                if (stop || !dynamic?.length) return;
                const staticSlugs = new Set(STATIC_BRANDS.map(b => b.slug));
                setBrands([
                    ...STATIC_BRANDS,
                    ...dynamic.filter(b => !staticSlugs.has(b.slug)),
                ]);
            })
            .catch(() => { });
        return () => { stop = true; };
    }, []);

    return brands;
}

// getBrand теперь принимает опциональный список
export function getBrand(slug, brandsList) {
    const list = brandsList || STATIC_BRANDS;
    return list.find((b) => b.slug === slug) || null;
}

export function getCategory(slug) {
    return CATEGORIES.find((c) => c.slug === slug) || null;
}